import { DebugLogger } from 'lib/debugLogger';
import { vkMusicBundleDebug } from 'reactApp/appHelpers/featuresHelpers/features/vkMusicBundle';

export const vkMusicBundleLogger = new DebugLogger({ DEBUG_SCOPE: 'VkMusicBundle', DEBUG: vkMusicBundleDebug });

export const VK_MUSIC_BUNDLE_PROMO_ID = 'vkmusic-bundle-promo-id';
export const VK_MUSIC_BUNDLE_DISABLED = `vkmusic-bundle-disabled`;

export const VK_MUSIC_RADAR_NAMES = {
    OFFER_MODAL: `mnz_vkmusic_free_users`,
    CONFIRM_MODAL: `mnz_vkmusic_сonfirm_modal`,
    ERROR_MODAL: `mnz_vkmusic_error_modal`,
    SUCCESS_MODAL: `vkmusic_success_modal`, // без mnz, так как не содержит СТА к оплате
    LANDING_BANNER: `mnz_vkmusic_free_users`,
};

/**
 * Точки входа для покупки бандла Mail Space + VK Музыка
 * @property {string} HOME_PROMO_OFFER - промо на хомяке
 * @property {string} LANDING_BANNER_OFFER - баннер на /promo/quota
 * @property {string} LANDING_QUERY_OFFER - переход по ссылке с параметром на /promo/quota
 */
export const enum VK_MUSIC_BUNDLE_SOURCE {
    HOME_PROMO_OFFER = 'home-promo',
    LANDING_BANNER_OFFER = 'landing-banner',
    LANDING_QUERY_OFFER = 'landing-query',
}

/**
 * Аналог VK_MUSIC_BUNDLE_SOURCE для прокидывания в окна оплаты
 */
export const VK_MUSIC_PAY_SOURCE = {
    [VK_MUSIC_BUNDLE_SOURCE.HOME_PROMO_OFFER]: `vkmusic_free_users_modal`,
    [VK_MUSIC_BUNDLE_SOURCE.LANDING_BANNER_OFFER]: `vkmusic_free_banner`,
    [VK_MUSIC_BUNDLE_SOURCE.LANDING_QUERY_OFFER]: `vkmusic_free_query_modal`,
};
